'use client'
import * as Breadcrumb from '@hashicorp/react-mds/src/hds/components/breadcrumb'

export interface BreadcrumbProps {
	url: string
	text: string
}

export interface BreadcrumbsProps {
	breadcrumbs: Array<BreadcrumbProps>
}

export default function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
	return (
		<Breadcrumb.Root>
			{breadcrumbs.map(({ url, text }, idx) => (
				<Breadcrumb.Item
					href={url}
					text={text}
					current={idx === breadcrumbs.length - 1}
					key={text}
				/>
			))}
		</Breadcrumb.Root>
	)
}
